<template>
  <div class="bg-container">
    <div class="bg-orange">
      <h1 class="bg-text">Enroll in Online Banking</h1>
      <h2>Enrolling in online banking is easy and takes just a few minutes.</h2>
      <div class="svg-container">
        <svg
          aria-hidden="true"
          height="100%"
          width="100%"
          preserveAspectRatio="none"
          viewBox="0 0 100 10"
          class="coh-inline-element"
        >
          <polygon points="0,0 0,100 100,10 0,0" class="coh-inline-element"></polygon>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TheHomepageBG",
}
</script>
